module.exports = __webpack_public_path__ + "img/20.3.TP.fb3fc9c0.png";